import iban from 'iban';

export default function(value) {
  if (!value) return true;
  return iban.isValid(value);
}
